import axios from "axios";

export default {
    async Table(data) {
        const response = await axios.post("/api/fueloperations/fuelprices/table", data);
        return response;
    },
    async ByLocation(province, district) {
        const response = await axios.get(`/api/fueloperations/fuelprices/bylocationparams/${province}/${district}`);
        return response;
    },
    async GetAvg() {
        const response = await axios.get("/api/fueloperations/fuelprices/getavgprice");
        return response;
    },
    async GetMinAndMax() {
        const response = await axios.get("/api/fueloperations/fuelprices/getminandmaxprice");
        return response;
    },
    async GetSquareRoot() {
        const response = await axios.get("/api/fueloperations/fuelprices/getsquarerootprice");
        return response;
    },
    async Stats(startDate, endDate) {
        const response = await axios.get(`/api/fueloperations/fuelprices/stats/${startDate}/${endDate}`);
        return response;
    },
    async TotalFuelLoadTable(data) {
        const response = await axios.post("/api/fueloperations/table/totalfuelloaddata", data);
        return response;
    },
    async TotalFuelLoadStats(data) {
        const response = await axios.post("/api/fueloperations/stats/totalfuelloaddata", data);
        return response;
    },
    async TotalFuelLoadPeriod() {
        const response = await axios.get("/api/fueloperations/invoiceperiods/totalfueldata");
        return response;
    },
    TotalFleet: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/fueloperations/update/totalfleetcode" : "/api/fueloperations/create/totalfleetcode", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/fueloperations/delete/totalfleetcode/${data}`);
            return response;
        },
        async Table(data) {
            const response = await axios.post("/api/fueloperations/table/totalfleetcode", data);
            return response;
        },
        async List() {
            const response = await axios.get("/api/fueloperations/select/list/totalfleetcode");
            return response;
        },
    },
    FuelSupplier: {
        async list() {
            const response = await axios.get("/api/storage/list/fuelsupplier");
            return response;
        },
        async getById(fuelSupplierId) {
            const response = await axios.get(`/api/storage/get/fuelsupplier/${fuelSupplierId}`);
            return response;
        },
        async create(data) {
            const response = await axios.post("/api/storage/create/fuelsupplier", data);
            return response;
        },
        async update(data) {
            const response = await axios.post("/api/storage/update/fuelsupplier", data);
            return response;
        },
        async delete(fuelSupplierId) {
            const response = await axios.get(`/api/storage/delete/fuelsupplier/${fuelSupplierId}`);
            return response;
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.update(data);
            } else {
                return await this.create(data);
            }
        },
    },
    PetrolOfisi: {
        async Table(data) {
            const response = await axios.post("/api/PetrolOfisi/Table", data);
            return response;
        },
        async Stats(data) {
            const response = await axios.post("/api/PetrolOfisi/Stats", data);
            return response;
        },
        FiloCode: {
            async Create(data) {
                return await axios.post("/api/PetrolOfisi/FiloCode/Create", data);
            },
            async Update(data) {
                return await axios.post("/api/PetrolOfisi/FiloCode/Update", data);
            },
            async Delete(id) {
                return await axios.post(`/api/PetrolOfisi/FiloCode/Delete/${id}`);
            },
            async Get(id) {
                return await axios.get(`/api/PetrolOfisi/FiloCode/Get/${id}`);
            },
            async List() {
                return await axios.get("/api/PetrolOfisi/FiloCode/List");
            },
            async Table(data) {
                return await axios.post("/api/PetrolOfisi/FiloCode/Table", data);
            },
        },
    },
};
